import { webappDisplayUrl } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";
import { slugify, useSlugAvailability } from "../lib/slug";
import "./auth-register.css";

const PLACEHOLDER_SLUG = "your-workspace";

/**
 * "Your workspace URL: app.<domain>/chat/<slug>" as the mockup draws it (`.slug`: one line, the address shortened with an
 * ellipsis). The live availability check (`GET /v1/workspaces/slug-available`) adds a tick at the end of that line when the
 * address is free, and a warning line only when it is taken: the server then adds a suffix, so the visitor is told.
 */
export function WorkspaceUrlHint({ name }: { name: string }) {
  const { t } = useTranslation();
  const slug = slugify(name);
  const status = useSlugAvailability(slug);
  const shown = slug || PLACEHOLDER_SLUG;
  const address = webappDisplayUrl(shown);
  const prefix = address.slice(0, address.length - shown.length);
  return (
    <>
      <div className="slug">
        <span className="slug-lead">{t("auth.register.workspaceUrl")}</span>
        <code>
          {prefix}
          <b key={shown} className="slug-name">
            {shown}
          </b>
        </code>
        {status === "available" ? (
          <span className="slug-ok" role="status">
            <Icon name="check-circle" />
            <span className="slug-ok-text">{t("auth.register.slugAvailable")}</span>
          </span>
        ) : null}
      </div>
      <p className="slug-status" role="status">
        {status === "taken" || status === "reserved" ? (
          <span className="slug-warn">
            <Icon name="alert-triangle" />
            {t("auth.register.slugTaken")}
          </span>
        ) : null}
      </p>
    </>
  );
}
